// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2.5H9.48063L11.4806 5H23V12.8027C22.1175 12.2922 21.0929 12 20 12C16.6863 12 14 14.6863 14 18C14 19.0929 14.2922 20.1175 14.8027 21H1V2.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 17V14H19V17H16V19H19V22H21V19H24V17H21Z"}}]};

const FolderAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-add-filled',
    ref,
    icon: element,
  },
));

FolderAddFilledIcon.displayName = 'FolderAddFilledIcon';

export default FolderAddFilledIcon;
